import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { categories } from '../data/places';
import type { PlaceCategory } from '../data/places';
interface FilterBarProps {
  selectedCategories: PlaceCategory[];
  onCategoryToggle: (category: PlaceCategory) => void;
  onClearFilters: () => void;
}
export function FilterBar({
  selectedCategories,
  onCategoryToggle,
  onClearFilters
}: FilterBarProps) {
  const getCategoryColor = (category: PlaceCategory) => {
    const colors: Record<string, string> = {
      Wildlife: 'from-emerald-500 to-teal-500',
      Nature: 'from-green-500 to-emerald-500',
      Culture: 'from-purple-500 to-pink-500',
      Historical: 'from-amber-500 to-orange-500',
      Shopping: 'from-rose-500 to-pink-500',
      'Markets & Crafts': 'from-orange-500 to-red-500',
      Dining: 'from-orange-500 to-red-500',
      Nightlife: 'from-purple-500 to-indigo-500',
      Adventure: 'from-blue-500 to-cyan-500',
      Family: 'from-green-500 to-lime-500',
      'Art & Museums': 'from-violet-500 to-purple-500'
    };
    return colors[category] || 'from-gray-500 to-gray-600';
  };
  return <div className="border-b-2 border-gray-100 bg-white" data-id="element-44">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6" data-id="element-45">
        <div className="flex items-center justify-between mb-5" data-id="element-46">
          <div className="flex items-center gap-3" data-id="element-47">
            <div className="h-1 w-8 bg-gradient-to-r from-teal-500 to-emerald-500 rounded-full" data-id="element-48" />
            <h3 className="text-sm font-bold text-charcoal uppercase tracking-wider" data-id="element-49">
              Filter by Category
            </h3>
          </div>
          {selectedCategories.length > 0 && <button onClick={onClearFilters} className="text-sm text-gray-600 hover:text-charcoal transition-colors flex items-center gap-1.5 font-semibold" data-id="element-50">
              <X className="w-4 h-4" strokeWidth={2.5} data-id="element-51" />
              Clear all
            </button>}
        </div>

        <div className="flex flex-wrap gap-3" data-id="element-52">
          {categories.map(category => {
          const isSelected = selectedCategories.includes(category);
          const gradient = getCategoryColor(category);
          return <motion.button key={category} onClick={() => onCategoryToggle(category)} className={`px-5 py-2.5 text-sm font-bold rounded-full transition-smooth ${isSelected ? `bg-gradient-to-r ${gradient} text-white shadow-lg` : 'bg-white text-gray-700 border-2 border-gray-200 hover:border-teal-300'}`} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-53">
                {category}
              </motion.button>;
        })}
        </div>
      </div>
    </div>;
}